import { Box, Skeleton, Stack, Typography } from "@mui/material";
import Image from "next/image";
import { useState } from "react";
import {
  badgeNumberSx,
  boxSkeletonSx,
  boxThumbnailSx,
  desStepSx,
  stackStepSx
} from "./ButtonInstallPWA.styles";
export interface InstallGuideModalProps {
  openModal: boolean;
  handleClose: () => void;
  handleInstall: () => void;
  /** Optional custom images for the 4 steps (will show nice placeholders if omitted) */
  stepImages?: [string?, string?, string?, string?];
  /** Optional “detail” href */
  detailsHref?: string;
  /** Optional product name to inject into headings */
  productName?: string; // default: "ウラハル"
  /** Optional Chrome icon url (svg/png). If not provided, a generic dot icon is used. */
  chromeIconUrl?: string;
}

export interface StepGuide {
  badge: string | number;
  img: string;
  textLines: string[];
  icon: React.ReactNode;
}

function StepCard({ badge, img, textLines, icon }: StepGuide) {
  const [loading, setLoading] = useState(true);
  const [errored, setErrored] = useState(false);

  return (
    <Stack direction="column" gap={1} sx={stackStepSx}>
      {/* Thumbnail */}
      <Box sx={boxThumbnailSx}>
        {!img || errored ? (
          <Box sx={boxSkeletonSx}>
            <Skeleton variant="rectangular" width="100%" height="100%" />
          </Box>
        ) : (
          <>
            {loading && (
              <Skeleton variant="rectangular" width="100%" height="100%" />
            )}
            <Image
              src={img}
              alt={`step-${badge}`}
              onLoad={() => setLoading(false)}
              onError={() => {
                setErrored(true);
                setLoading(false);
              }}
              width={0}
              priority
              height={0}
              sizes="80vw"
              style={{
                width: "100%",
                minWidth: 100,
                height: "auto",
                borderRadius: "16px 16px 0 0"
              }}
            />
          </>
        )}
      </Box>
      <Typography component="p" sx={desStepSx}>
        <span className="inline-flex mr-1">
          <Box component="span" sx={badgeNumberSx}>
            {badge}
          </Box>
        </span>
        {textLines[0]}
        {icon && <span className="inline-flex ml-1 mr-1">{icon}</span>}
        {textLines[1]}
      </Typography>
    </Stack>
  );
}

export default StepCard;
